import axiosInstance from './axiosInstance';

export type UploadArtworkParams = {
  /** 图片文件 list */
  files: File[];
  /** 作品描述 */
  description?: string;
  /** 作品标题 */
  title?: string;
  /** 作品标签 */
  tags?: string[];
  token: string;
};

/**
 * @description 上传作品接口
 *
 * @see https://test-yapi.supptech.net/project/32/interface/api/903
 */
export const uploadArtwork = async (
  data: UploadArtworkParams,
  authToken: string
) => {
  const formData = new FormData();

  data.files.forEach((file) => {
    formData.append('files', file);
  });

  if (data.description) formData.append('description', data.description);
  if (data.title) formData.append('title', data.title);
  if (data.tags) {
    data.tags.forEach((tag) => formData.append('tags[]', tag));
  }

  const response = await axiosInstance.post(
    `${SUPP_APP_GATEWAY_URL}/artwork-content/api/artwork/v1/publish`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: authToken,
      },
    }
  );

  return response.data;
};
